import { numeralFormat } from '../../../../../../lib/renderUtil'

const withPrice = MainComponent => {
  return (props) => {
    const { className, input: { value } } = props
    const priceAmount = numeralFormat(value, { format: '$ 0,00', allowZero: true })
    return (
      <MainComponent
        className={className}
        content={priceAmount}
      />
    )
  }
}
export default withPrice
